export default "__VITE_ASSET__P89Q8bPk__"